import { render, staticRenderFns } from "./Obstetric.vue?vue&type=template&id=9f0f8452&scoped=true"
import script from "./Obstetric.vue?vue&type=script&lang=js"
export * from "./Obstetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0f8452",
  null
  
)

export default component.exports